<template>
  <div
    class="address__row"
    :class="{
      'address__row-extra__location': isExtraAddress,
      'address__row-extra__location__last': isLastExtraAddress,
      mobile: mobile
    }"
    @click="handleClick"
  >
    <v-list-tile-avatar>
      <div class="address__row-extra__location__icon" v-if="data.isExtraPoint">
        <img
          :src="
            selected
              ? '/v1/assets/images/icLocationDetailsFull.png'
              : '/v1/assets/images/icLocationDetails.png'
          "
        />
      </div>
      <SvgIcon v-else width="24" height="24" :icon="icon" />
    </v-list-tile-avatar>

    <v-list-tile-content v-if="isExtraAddress" data-test-id="address_suggest">
      <span>{{ data.extraAddressName }}</span>
    </v-list-tile-content>

    <v-list-tile-content v-else data-test-id="address_suggest" :title="hint">
      <v-list-tile-title v-dompurify-html="firstLabel" />
      <v-list-tile-sub-title>
        <span v-dompurify-html="secondLabel" />
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    data: {
      type: Object,
      require: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      let icon = 'SearchPlaceIcon'
      if (this.data && this.data.address_type) {
        switch (this.data.address_type) {
          // case this.$constants.ADDRESS_TYPE.HOME:
          //   icon = "home";
          //   break;
          // case this.$constants.ADDRESS_TYPE.WORK:
          //   icon = "work";
          //   break;
          case this.$constants.ADDRESS_TYPE.SAVED_PLACE:
            icon = 'SavedPlaceIcon'
            break
          case this.$constants.ADDRESS_TYPE.HISTORY:
            icon = 'HistoryPlaceIcon'
            break
          case this.$constants.ADDRESS_TYPE.PREDICT_DEFAULT:
          case this.$constants.ADDRESS_TYPE.PREDICT_KONTAKTE:
            icon = 'SearchPlaceIcon'
            break
          default:
            icon = 'SearchPlaceIcon'
        }
      }

      return icon
    },
    isExtraAddress() {
      return (
        this.data &&
        this.data.address_type === this.$constants.ADDRESS_TYPE.PREDICT_DEFAULT &&
        this.data.isExtraPoint
      )
    },
    isLastExtraAddress() {
      return (
        this.data &&
        this.data.address_type === this.$constants.ADDRESS_TYPE.PREDICT_DEFAULT &&
        this.data.isLastExtraPoint
      )
    },
    firstLabel() {
      const { first_label } = this.data

      return first_label
    },
    secondLabel() {
      return this.data.second_label
    },
    hint() {
      return `${this.data.address}`
    }
  },
  methods: {
    handleClick($event) {
      this.$emit('onClick', { $event, data: this.data })
    }
  }
}
</script>

<style lang="scss" scoped>
.address__row {
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f1f1f1;
  display: flex;

  .v-list {
    .v-list__tile {
      border-bottom: 1px solid #eee;
    }
  }

  .v-list__tile__content {
    .v-list__tile__title {
      line-height: 21px;
      height: 21px;
      color: #000;
    }

    .v-list__tile__sub-title {
      color: #7a8189;
    }
  }

  .v-list__tile__avatar {
    min-width: 45px;
    margin-left: -0.5rem;
  }
}

.mobile {
  .v-list__tile__avatar {
    min-width: 45px;
    margin-left: 0;
  }

  .v-list__tile__content {
    flex: 1 1;
    margin-right: 16px;

    .v-list__tile__title {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #21272a;
    }

    .v-list__tile__sub-title {
      color: #4d5358;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;

      span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.address__row-extra__location {
  margin-left: 53px;
  align-items: center;

  .address__row-extra__location__icon {
    img {
      width: 10px;
      height: 10px;
    }
  }

  .v-list__tile__avatar {
    min-width: 24px;
    width: 24px;
    margin-right: 5px;
  }
}

.address__row-extra__location__last {
  margin-left: 0;
  padding-left: 53px;
}

@media only screen and (max-width: 719px) {
  .address__row {
    // width: 83vw;
    height: 68px;

    .v-list__tile__title {
      font-size: 14px;
    }

    .v-list__tile__sub-title {
      font-size: 13px;
      line-height: 15px;
      white-space: normal;
    }

    .v-avatar {
      height: 54px !important;
      width: 56px !important;
    }
  }

  .address__row-extra__location {
    .v-list__tile__content {
      font-size: 14px;
    }
  }
}
</style>
